/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */
import * as constants from '../constants'
import type { ActionTypes } from './types'

// This satisfies makes sure that everything in the whitelist is also used in the reducer
const whitelist = Object.values(constants) satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<ActionTypes['type'], (typeof whitelist)[number]>
false && (shouldBeEmpty satisfies never)

export default whitelist
